import { Controller } from "stimulus";

export default class extends Controller {
  track(event) {
    try {
      const data = event.target.dataset;

      window.fbq("track", "ViewContent", {
        content_name: data.contentName,
        content_category: data.contentCategory,
      });
    } catch (error) {}
  }
}
